











import { Component, Prop, Vue } from "vue-property-decorator";
import { sanitizeRichText } from "@/utils/sanitize";

@Component
export default class AnswerContent extends Vue {
  @Prop() private readonly answer_content!: string;

  private panel = 0;

  /** HTML用回答内容 */
  private get htmlAnswerContent() {
    return sanitizeRichText(this.answer_content.replace(/\r?\n/g, "<br>"));
  }
}
